import React from 'react';
import classNames from 'classnames';

import css from './NotificationBadge.css';

const NotificationBadge = props => {
  const { className, rootClassName, count } = props;
  const classes = classNames(rootClassName || css.root, className);

  return <span className={classes}>{count}</span>;
};

export default NotificationBadge;
